import { Component, HostBinding, Input } from '@angular/core';
import { Dimension, FlexPosition, TextAlign } from './section.model';

@Component({
  selector: 'wb-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent {
  @Input() class = '';
  @Input() size!: Dimension;
  @Input() horizontal!: Dimension;
  @Input() vertical!: Dimension;
  @Input() top!: Dimension;
  @Input() right!: Dimension;
  @Input() bottom!: Dimension;
  @Input() left!: Dimension;
  @Input() gap!: Dimension;
  @Input() isFullWidth = false;
  @Input() justifyContent!: FlexPosition;
  @Input() alignContent!: FlexPosition;
  @Input() alignItems!: FlexPosition;
  @Input() textAlign!: TextAlign;
  @Input() direction!: 'column' | 'row';
  @Input() wrap = true;

  @HostBinding('style.max-width.px') @Input() maxWidth!: number;

  @HostBinding('class') get getClasses(): string {
    return [
      this.class,
      `section--${this.size}`,
      this.horizontal ? `section-horizontal--${this.horizontal}` : '',
      this.vertical ? `section-vertical--${this.vertical}` : '',
      this.top ? `section-top--${this.top}` : '',
      this.right ? `section-right--${this.right}` : '',
      this.bottom ? `section-bottom--${this.bottom}` : '',
      this.left ? `section-left--${this.left}` : '',
      this.gap ? `section-gap--${this.gap}` : '',
      this.justifyContent ? `section-justify-content--${this.justifyContent}` : '',
      this.alignItems ? `section-align-items--${this.alignItems}` : '',
      this.alignContent ? `section-align-content--${this.alignContent}` : '',
      this.direction ? `section-direction--${this.direction}` : '',
      this.isFullWidth ? `section--is-full-width` : '',
      this.maxWidth ? 'section--is-max-width' : '',
      this.wrap ? `section--wrap` : 'section--nowrap',
      this.textAlign ? `section-text-align--${this.textAlign}` : '',
    ].join(' ');
  }
}
